<div class="tab-content">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">

        <div class="hero-text" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'COMPANY_ADDITION_FORM'|translate}}</h1>
        </div>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'FUEL'|translate}}</mat-label>
            <mat-select [(ngModel)]="model.fuel" placeholder="{{'FUEL'|translate}}" name="fuel">
                <mat-option *ngFor="let item of globalConfigFuelEnum | keyvalue" [value]="item.value">{{item.key|translate}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'DISTANCE'|translate}}</mat-label>
            <mat-select [(ngModel)]="model.distance" placeholder="{{'DISTANCE'|translate}}" name="distance">
                <mat-option *ngFor="let item of globalConfigDistanceEnum | keyvalue" [value]="item.value">{{item.key|translate}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'CASH'|translate}}</mat-label>
            <mat-select [(ngModel)]="model.cash" placeholder="{{'CASH'|translate}}" name="cash">
                <mat-option *ngFor="let item of globalConfigCashEnum | keyvalue" [value]="item.value">{{item.key|translate}}</mat-option>
            </mat-select>
        </mat-form-field>

        <button mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </form>
</div>